var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#E3F7F2",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.13 16.195h-1.113l-2.498-2.498a.684.684 0 0 0-.476-.197h-8.086c-.17 0-.349.07-.476.197l-2.498 2.498h-1.114a3.373 3.373 0 0 0-3.369 3.37v14.914c0 1.114.907 2.021 2.021 2.021H34.48a2.024 2.024 0 0 0 2.021-2.021V19.564a3.373 3.373 0 0 0-3.37-3.369zm-4.014-.995 1.733 1.732-3.227 4.302L25.89 19.5l3.226-4.301zm-8.232 0L24.11 19.5l-1.732 1.733-3.227-4.302 1.733-1.732zm3.442 19.952h-8.805a.675.675 0 0 1-.673-.673V19.564c0-1.114.906-2.021 2.021-2.021h1.056l3.84 5.121a.674.674 0 0 0 1.016.072l1.545-1.545v13.961zm-2.021-20.304h5.39L25 18.44l-2.695-3.593zm12.847 19.63a.675.675 0 0 1-.673.674h-8.805v-13.96l1.545 1.544c.289.29.769.257 1.015-.072l3.841-5.121h1.056c1.115 0 2.021.907 2.021 2.021V34.48z",
    fill: "#00C2C2",
    stroke: "#00C2C2",
    strokeDasharray: "0,0",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoProduct);
export default __webpack_public_path__ + "static/media/ic_no_product.f6d04c7106a0cc5c72c6b866f9b6bf45.svg";
export { ForwardRef as ReactComponent };